import { render } from "./Index.vue?vue&type=template&id=595e44a4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=595e44a4&lang=scss&scoped=true"

import exportComponent from "/var/www/kostyum-admin-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595e44a4"]])

export default __exports__